import gql from 'graphql-tag';

const deleteAssetsMutation = gql`
    mutation DeleteAssetsMutation($input: DeleteArchiveAssetsInput!) {
        deleteAssets(input: $input)
    }
`;

const deleteAssets = {
  mutation: deleteAssetsMutation,
  module: 'assets',
  buildVariables: (assetIds) => ({
    input: { assetIds }
  })
};

export default deleteAssets;